import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import "../assets/scss/style.css";
import {
  IconButton,
  Typography,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Backdrop,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../assets/images/ai.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import EditIcon from "@mui/icons-material/Edit";
import { getDateFormat, errorHandling, BackdropStyles, CircularProgressStyles, DialogStyles, ButtonStyles } from "../utils/general";
import { ACCOUNT_INITIALIZE, SET_MODE } from "../store/actions";
import configData from "../config";
import axios from "axios";
import ValidateIcon from "@mui/icons-material/CheckCircle";
import Logout from "@mui/icons-material/Logout";
import SummarizeIcon from "@mui/icons-material/Summarize";
import DownloadIcon from "@mui/icons-material/Download";
import { useTheme } from '@mui/styles';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import MenuIcon from "@mui/icons-material/Menu";
import { useRef, useEffect } from "react";
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AssignmentIcon from '@mui/icons-material/Assignment'; 
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay'; 
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VideocamIcon from '@mui/icons-material/Videocam';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import CampaignIcon from '@mui/icons-material/Campaign';
import SettingsIcon from '@mui/icons-material/Settings';
import UploadIcon from '@mui/icons-material/Upload';
import PersonIcon from '@mui/icons-material/Person';
import BlockableLink from '../components/BlockableLink';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DoneIcon from '@mui/icons-material/Done';
import { SET_MENU } from "../store/actions";
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  iconMenu: {
    position: "fixed",
    top: "50px", 
    left: 0,
    height: "auto",
    width: "220px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    padding: "0px 4px",
    zIndex: 1000,
    overflowY: "auto",
    maxHeight: "calc(100vh - 50px)",
    // fontFamily: "Montserrat",
  },
  iconItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textAlign: "left",
    color: "#FCFCFC",
    textDecoration: "none",
    padding: "5px",
    width: "100%",
    gap: "10px", 
    borderRadius: "8px",
    transition: "all 0.3s",
    fontFamily: "IBM Plex Sans, sans-serif",
    "&:hover": {
      backgroundColor: theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa",
      transform: "translateX(4px)",
    },
  },
  iconImage: {
    // width: 35,
    // height: 35,
    borderRadius: "5%",
    // backgroundColor: "black",
    backgroundSize: "cover",
    backgroundPosition: "center",
    flexShrink: 0,
  },
  "@media (min-width: 1028px)": {
    iconMenu: {
      overflowX: "hidden",
      justifyContent: "flex-start",
    },
    iconItem: {
      width: "100%",
    },
  },
}));

function FixedMenuLayout() {
  const classes = useStyles();
  const account = useSelector((state) => state.account);
  const Customization = useSelector((state) => state.customization);
  const { token, user, permissions, authMenu, refresh, project } = account;
  const dispatcher = useDispatch();
  const dispatch = useDispatch();
  console.log(project)

  const [projectExpand, setProjectExpand] = useState(false);
  const [editProjectDialog, setEditProjectDialog] = useState(false);
  const [projectUpdate, setProjectUpdate] = useState(project);
  const [dialogError, setDialogError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subAnchorEl, setSubAnchorEl] = useState(null);
  const [menuExpand, setMenuExpand] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [displayFilter, setDisplayFilter] = useState(project.history_display ?? "All");
  const [filterSubmitted, setFilterSubmitted] = useState(false);
  const [filterErrorDialog, setFilterErrorDialog] = useState(false);

  const menuRef = useRef(null);

  const theme = useTheme();

  const location = useLocation();
  const path = location.pathname;

  const noMenuPages = ['/dashboard', '/user_profile_list', '/organization_profile_list'];

  const cleanPath = path.split('?')[0].replace(/\/$/, '');
  const isNoMenuPage = noMenuPages.some(route => cleanPath.startsWith(route));

  const leftDrawerOpened = useSelector((state) => state.customization.opened);


  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuExpand(false);
      }
    }
    
    if (menuExpand) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuExpand]);

  const handleClose = () => {
    setProjectExpand(false);
  };

  function handleThemeChange(){
    if(Customization.themeMode == 'dark'){
      dispatcher({ type: SET_MODE, themeMode: 'light' });
    } else if(Customization.themeMode == 'light'){
      dispatcher({ type: SET_MODE, themeMode: 'dark' });
    }
    handleMenuClose();
  }

  const icons = [
    { name: "DashBoard", icon: <DashboardIcon />, link: "/dashboard", id: 'dashboard' },
    { name: "Upload Assets", icon: <CloudUploadIcon />, link: "/upload_movie_asstes", id: 'upload_movie_assets' },
    { name: "Edit Scenes", icon: <PlaylistPlayIcon />, link: `/video_management_data?id=${project.id}&flag=false`, id: 'video_management_report' },
    { name: "Scene View", icon: <VisibilityIcon />, link: `/scene_view?id=${project.id}`, id: 'scene_view' },
    { name: "Validation Summary", icon: <SummarizeIcon />, link: `/data_validation_report?id=${project.id}&flag=false`, id: 'summary_report' },
    { name: "Progress Status", icon: <UploadIcon />, link: `/progress_status_list?id=${project.id}`, id: 'progress_status' },
    {
      name: "Reports",
      icon: <AssignmentIcon />,
      children: [
        { name: "Script Report", icon: <MenuBookIcon />, link: `/script_report?id=${project.id}`, id: 'script' },
        { name: "Continuity Report", icon: <CameraswitchIcon />, link: `/continuity_report?id=${project.id}`, id: 'continuity_report' },
        { name: "Log Report", icon: <AssignmentIcon />, link: `/log_report?id=${project.id}`, id: 'log_report' },
        { name: "Camera Report", icon: <VideocamIcon />, link: `/camera_report?id=${project.id}`, id: 'camera_report' },
        { name: "Sound Report", icon: <CampaignIcon />, link: `/sound_report?id=${project.id}`, id: 'sound_report' },
      ],
    },
    // { name: "Script", icon: <MenuBookIcon />, link: `/script_report?id=${project.id}`, id: 'script' },
    // // { name: "Character List", icon: <PersonIcon />, link: `/character_list?id=${project.id}`, id: 'character_list' },
    // { name: "Log Report", icon: <AssignmentIcon />, link: `/log_report?id=${project.id}`, id: 'log_report' },
    // { name: "Camera Report", icon: <VideocamIcon />, link: `/camera_report?id=${project.id}`, id: 'camera_report' },
    // { name: "Continuity Report", icon: <CameraswitchIcon />, link: `/continuity_report?id=${project.id}`, id: 'continuity_report' },
    // { name: "Sound Report", icon: <CampaignIcon />, link: `/sound_report?id=${project.id}`, id: 'sound_report' },
    // { name: "Video File Management X", icon: <PlaylistPlayIcon />, link: `/sequence_data?id=${project.id}&flag=false`, id: 'sequence_report' },
    // { name: "Settings", icon: <SettingsIcon onClick={(e) => setAnchorEl(e.currentTarget)} /> },
    { name: "Logout", icon: <Logout />, link: "/logout", id: 'logout' },
  ];

  const isActive = (icon, child = null) => {
    if (child) {
      return path.startsWith(child.link.split("?")[0]);
    }
    if (icon.children) {
      return false;
    }
    return path.startsWith(icon.link.split("?")[0]);
  };


  useEffect(() => {
    icons.forEach(icon => {
      if (icon.children && icon.children.some(c => path.startsWith(c.link.split("?")[0]))) {
        setMenuExpand(icon.name);
      }
    });
  }, [path]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubAnchorEl(null);
    setFilterAnchorEl(null);
  };

  function handleDialogClose() {
    setDialogError(null);
    setEditProjectDialog(false);
    setProjectUpdate(project);
    setFilterErrorDialog(false)
  }

  function handleProjectSubmit() {
    if (
      !projectUpdate.name ||
      !projectUpdate.type ||
      !projectUpdate.genre ||
      !projectUpdate.project_by ||
      !projectUpdate.script_writer_name
    ) {
      setDialogError(
        <span style={{ color : "#ff4d4d" }}>Please fill all the mandatory fields. indicated *</span>
      );
      return false;
    }

    const sendingData = {
      name: projectUpdate.name,
      type: projectUpdate.type,
      genre: projectUpdate.genre,
      project_by: projectUpdate.project_by,
      script_writer_name: projectUpdate.script_writer_name,
    };

    const banner_file = document.getElementById("banner_file");
    const projectForm = new FormData();
    Object.keys(sendingData).forEach((key) => {
      projectForm.append(key, sendingData[key]);
    });

    if (banner_file && banner_file.value !== "") {
      const file = banner_file.files[0];
      projectForm.append("banner_file", file);
    }

    setSubmitted(true);
    axios
      .patch(
        configData.API_SERVER + "projects/" + project.id + "/",
        projectForm
      )
      .then((response) => {
        setSubmitted(true);
        dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
            isLoggedIn: true,
            user: user,
            token: token,
            permissions: permissions,
            authMenu: authMenu,
            refresh: refresh,
            project: projectUpdate,
          },
        });
        if (response.data) {
          setDialogError(
            <span style={{ color: "green" }}>Data submitted successfully</span>
          );
        } else {
          setDialogError(
            <span style={{ color : "#ff4d4d" }}>Data submission failed</span>
          );
          return false;
        }
        setTimeout(() => {
          setRedirect(true);
          setEditProjectDialog(false);
          setSubmitted(false);
          setTimeout(() => {
            setRedirect(false);
            setDialogError(null);
          }, 1000);
        }, 3000);
      })
      .catch((error) => {
        setSubmitted(false);
        errorHandling(error.response, setDialogError);
      });
  }

  function handleDisplayFilter(value){
    if(displayFilter != value){
      const sendingData = {
        history_display: value
      }
      const project_data = { ...projectUpdate, history_display: value }

      setFilterSubmitted(true);
      axios.patch(configData.API_SERVER + "projects/" + project.id + "/", sendingData)
      .then((response) => {
        setDisplayFilter(value);
        setProjectUpdate(project_data);
        dispatcher({
          type: ACCOUNT_INITIALIZE,
          payload: {
            isLoggedIn: true,
            user: user,
            token: token,
            permissions: permissions,
            authMenu: authMenu,
            refresh: refresh,
            project: project_data,
          },
        });
        setFilterAnchorEl(null);
        setAnchorEl(null);
        setTimeout(() => {
          setFilterSubmitted(false);
        }, 1500)
      }).catch((error) => {
        setFilterSubmitted(false);
        setFilterErrorDialog(true);
      })
    }
  }

  return (
    <div>
      <Grid
        item
        xs={12}
        container
        justifyContent="space-between"
        alignItems="center"
        backgroundColor={theme.palette.themeMode == 'dark' ? "#1D2029" : theme.palette.primary.dark}
        sx={{ px: 2 }}
      >
        <Grid item sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <BlockableLink to={`/dashboard`}>
            {/* <img
              src={logo}
              alt="Logo"
              style={{ width: 90, height: 40, marginRight: 10, borderRadius: 5 }}
            /> */}
            <span style={{ color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A",  fontSize: "22px"}} width="90" height="40">Tachi Ai</span>
          </BlockableLink>
          <IconButton onClick={() => dispatch({ type: SET_MENU, opened: !leftDrawerOpened })} size="large">
            <MenuIcon sx={{ color: theme.palette.themeMode === 'dark' ? theme.palette.primary.dark : "#0A0A0A" }} />
          </IconButton>

        </Grid>
        <Typography
          variant="h1"
          align="center"
          color={theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A"}
          marginTop={1}
          sx={{ flexGrow: 1, "@media (max-width: 768px)": {fontSize: "15px"} }}
          marginRight={15}
        >
          {project.name}
          <IconButton
            onClick={() => setProjectExpand(!projectExpand)}
            color={theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A"}
          >
            {!projectExpand ? <ExpandMoreIcon sx={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}/> : <ExpandLessIcon sx={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}/>}
          </IconButton>
        </Typography>
        {/* <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <SettingsIcon sx={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }} />
        </IconButton> */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark, 
            },
          }}
        >
        <Grid 
          style={{
            backgroundColor: theme.palette.themeMode == 'dark' ? "#1D2029" : theme.palette.primary.dark, 
              }}
        >
          <MenuItem onClick={handleThemeChange}
          sx={{
            borderRadius: "8px",
            transition: "all 0.3s",
            '&:hover': {
              backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
              transform: "translateX(4px)",
            }
          }}
          >
            {Customization.themeMode == 'dark' ? 
            (<>
              <LightModeIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Light Mode</span>
            </>) : (<>
              <DarkModeIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Dark Mode</span></>)
            }
          </MenuItem>
          <BlockableLink
            to={"/project_overview"}
            style={{ textDecoration: "none", color: "grey" }}
          >
            <MenuItem onClick={handleMenuClose}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <SummarizeIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Project Overview</span>
            </MenuItem>
          </BlockableLink>
          {filterSubmitted && 
            <Backdrop open={true} sx={BackdropStyles()}>
              <CircularProgress sx={{ ...CircularProgressStyles(), color: "#314BCA" }}/>
            </Backdrop>
          }
          <MenuItem
            onClick={(e) => setFilterAnchorEl(e.currentTarget)}
            sx={{ borderRadius: "8px", transition: "all 0.3s", textDecoration: "none", color: "grey", '&:hover': { backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa", transform: "translateX(4px)",
            } }}
          >
            <FilterAltIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Display Filter</span>
          </MenuItem>
          <Menu
            anchorEl={filterAnchorEl}
            open={Boolean(filterAnchorEl)}
            onClose={() => setFilterAnchorEl(null)}
            PaperProps={{
              style: {
                backgroundColor: 'lightblue',
                borderRadius: '10px',backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark, 
              },
            }}
          >
            <Grid
              style={{
                borderRadius: "8px",
                transition: "all 0.3s",
                backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark
              }}
            >
              <MenuItem onClick={() => handleDisplayFilter("Week")}
                sx={{
                  backgroundColor: displayFilter === "Week" && (theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa"),
                  '&:hover': {
                    transition: "all 0.3s",
                    backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                    transform: "translateX(4px)",
                  }
                }}
              >
                <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Last Week</span>
                {displayFilter == "Week" && 
                  <DoneIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
                }
              </MenuItem>
              <MenuItem onClick={() => handleDisplayFilter("Month")}
                sx={{
                  backgroundColor: displayFilter === "Month" && (theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa"),
                  '&:hover': {
                    transition: "all 0.3s",
                    backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                    transform: "translateX(4px)",
                  }
                }}
              >
                <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Last Month</span>
                {displayFilter == "Month" && 
                  <DoneIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
                }
              </MenuItem>
              <MenuItem onClick={() => handleDisplayFilter("All")}
                sx={{
                  backgroundColor: displayFilter === "All" && (theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa"),
                  '&:hover': {
                    transition: "all 0.3s",
                    backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                    transform: "translateX(4px)",
                  }
                }}
              >
                <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>All</span>
                {displayFilter == "All" && 
                  <DoneIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
                }
              </MenuItem>
            </Grid>   
          </Menu>
          <MenuItem
            onClick={(e) => setSubAnchorEl(e.currentTarget)}
            sx={{ borderRadius: "8px", transition: "all 0.3s", textDecoration: "none", color: "grey", '&:hover': { backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa", transform: "translateX(4px)",
            } }}
          >
            <DownloadIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
            <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Download Template</span>
          </MenuItem>

          <Menu
            anchorEl={subAnchorEl}
            open={Boolean(subAnchorEl)}
            onClose={() => setSubAnchorEl(null)}
            PaperProps={{
              style: {
                backgroundColor: 'lightblue',
                borderRadius: '10px',backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark, 
              },
            }}
          >
            <Grid
              style={{
                borderRadius: "8px",
                transition: "all 0.3s",
                backgroundColor: theme.palette.themeMode == 'dark' ? theme.palette.primary.light : theme.palette.primary.dark
                  }}
            >
            <RouterLink
            to={'https://aiedit.itconnectus.com/project_templates/script_file_standard_template.zip'}
            style={{ textDecoration: "none", color: "grey" }}
            >
            <MenuItem onClick={() => setSubAnchorEl(null)}
            sx={{
              '&:hover': {
                borderRadius: "8px",
                transition: "all 0.3s",
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Script Report</span>
            </MenuItem>
            </RouterLink>
            <RouterLink
            to={'https://aiedit.itconnectus.com/project_templates/log_report_standard_template.zip'}
            style={{ textDecoration: "none", color: "grey" }}
            >
            <MenuItem onClick={() => setSubAnchorEl(null)}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Log Report Template</span>
            </MenuItem>
            </RouterLink>
            <RouterLink
            to={'https://aiedit.itconnectus.com/project_templates/camera_report_standard_template.zip'}
            style={{ textDecoration: "none", color: "grey" }}
            >
            <MenuItem onClick={() => setSubAnchorEl(null)}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Camera Report Template</span>
            </MenuItem>
            </RouterLink>
            <RouterLink
             to={'https://aiedit.itconnectus.com/project_templates/continuity_report_standard_template.zip'}
             style={{ textDecoration: "none", color: "grey" }}
            >
            <MenuItem onClick={() => setSubAnchorEl(null)}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Continuity Report Template</span>
            </MenuItem>
            </RouterLink>
            <RouterLink
             to={'https://aiedit.itconnectus.com/project_templates/sound_report_standard_template.zip'}
             style={{ textDecoration: "none", color: "grey" }}
            >
            <MenuItem onClick={() => setSubAnchorEl(null)}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Sound Report Template</span>
            </MenuItem>
            </RouterLink>
            </Grid>
          </Menu>

          <BlockableLink
            to={`/data_validation_report?id=${project.id}&flag=true`}
            state={project}
            style={{ textDecoration: "none", color: "grey" }}
          >
            <MenuItem onClick={handleMenuClose}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <ValidateIcon sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
              <span style={{ padding: "5px", fontSize: '14px',fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Generate Validation Summary</span>
            </MenuItem>
          </BlockableLink>
          <BlockableLink
            to={"/logout"}
            style={{ textDecoration: "none", color: "grey" }}
          >
            <MenuItem onClick={handleMenuClose}
            sx={{
              borderRadius: "8px",
              transition: "all 0.3s",
              '&:hover': {
                backgroundColor: theme.palette.themeMode == 'dark' ? "#91887e" : "#87cefa",
                transform: "translateX(4px)",
              }
            }}
            >
              <Logout sx={{ color: theme.palette.themeMode == 'dark' ? "#314BCA" : "#314BCA" }}/>
              <span style={{ padding: "5px", fontSize: '14px', fontWeight: '600', color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Logout</span>
            </MenuItem>
          </BlockableLink>
          </Grid>
        </Menu>
        </Grid>
        {!isNoMenuPage && leftDrawerOpened && (
        <div
          style={{
            position: "fixed",
            top: "58px",
            left: 0,
            width: "220px",
            height: "100vh",
            backgroundColor: theme.palette.themeMode === "dark" 
              ? "#1D2029" 
              : "#fff",
            overflowY: "auto",
            transition: "all 0.3s ease",
            zIndex: 1000,
          }}
        >
          <Grid item xs={12}>
            {icons.map((icon, index) =>
              icon.children ? (
                <div key={index}>
                  <div
                    onClick={() => setMenuExpand(menuExpand === icon.name ? null : icon.name)}
                    className={classes.iconItem}
                    style={{ cursor: "pointer", backgroundColor: "transparent" }}
                  >
                    <div style={{ color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>{icon.icon}</div>
                    <Typography variant="caption" sx={{ fontSize: 14, fontWeight: 600, color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>
                      {icon.name}
                    </Typography>
                    {menuExpand === icon.name ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </div>

                  {menuExpand === icon.name && (
                    <div style={{ marginLeft: "20px" }}>
                      {icon.children.map((child, idx) => (
                        <BlockableLink
                          to={child.link}
                          key={idx}
                          state={project}
                          className={classes.iconItem}
                          style={{
                            backgroundColor: isActive(icon, child)
                              ? (theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa")
                              : "transparent"
                          }}
                        >
                          <div style={{ color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>{child.icon}</div>
                          <Typography variant="caption" sx={{ fontSize: 13, fontWeight: 600, color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>
                            {child.name}
                          </Typography>
                        </BlockableLink>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <BlockableLink
                  to={icon.link}
                  key={index}
                  state={project}
                  className={classes.iconItem}
                  style={{
                    backgroundColor: isActive(icon)
                      ? (theme.palette.themeMode === 'dark' ? "#91887e" : "#87cefa")
                      : "transparent"
                  }}
                >
                  <div style={{ color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>{icon.icon}</div>
                  <Typography variant="caption" sx={{ fontSize: 14, fontWeight: 600, color: theme.palette.themeMode === 'dark' ? "#fff" : "#0A0A0A" }}>
                    {icon.name}
                  </Typography>
                </BlockableLink>
              )
            )}
          </Grid>
        </div>
      )}
      {projectExpand && (<>
        <Box
          onClick={handleClose}
          sx={{
            position: "fixed",
            top: 0,
            left: leftDrawerOpened ? "220px" : 0,
            width: leftDrawerOpened ? "calc(100% - 220px)" : "100%", 
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(2px)",
            zIndex: 998,
          }}
        />
        <Grid
          item
          xs={12}
          container
          spacing={1}
          marginTop={10}
          style={{
            position: "fixed",
            top: "10%",
            left: "60%",
            transform: "translate(-50%, -50%)",
            backgroundColor: theme.palette.themeMode == 'dark' ? "#2C2B4C" : theme.palette.primary.dark,
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.8)",
            zIndex: 1500,
            color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A",
             width: leftDrawerOpened ? "calc(100% - 240px)" : "80%",
            maxWidth: "900px"
          }}
        >
          <Grid item xs={12}>
            <IconButton
              sx={{ position: "absolute", top: 8, right: 8 }}
              onClick={() => setEditProjectDialog(true)}
            >
              <EditIcon style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}/>
            </IconButton>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Project Name</label>
            </Grid>
            <Grid item xs={0.3} style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {project.name}
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Date</label>
            </Grid>
            <Grid item xs={0.3} style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {getDateFormat(project.date)}
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Project Type</label>
            </Grid>
            <Grid item xs={0.3} style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {project.type}
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Project Genre</label>
            </Grid>
            <Grid item xs={0.3} style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {project.genre}
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Project By</label>
            </Grid>
            <Grid item xs={0.3} style={{color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {project.project_by}
            </Grid>
          </Grid>
          <Grid item container xs={12} sm={6}>
            <Grid item xs={6}>
              <label className="form-label0" style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>Script Writer Name</label>
            </Grid>
            <Grid item xs={0.3} style={{ color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              :
            </Grid>
            <Grid item xs={5} style={{ wordWrap: "break-word", color: theme.palette.themeMode == 'dark' ? theme.palette.primary.dark : "#0A0A0A" }}>
              {project.script_writer_name}
            </Grid>
          </Grid>
        </Grid>
      </>)}

      <Dialog
        open={editProjectDialog}
        // onClose={handleDialogClose}
        onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              handleDialogClose();
            }
          }}
        sx={DialogStyles(theme)}
      >
        <DialogContent>
          <span style={{ fontWeight: "bold", color: "#314BCA" }}>
            Edit the project details
            <br />
          </span>
          <TextField
            autoFocus
            margin="dense"
            id="project_name"
            label={
              <span style={{ fontSize: "13px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>
                Project Name <span style={{ color : "#ff4d4d" }}>*</span>
              </span>
            }
            type="text"
            variant="standard"
            fullWidth
            value={projectUpdate && projectUpdate.name}
            onChange={(e) =>
              setProjectUpdate({ ...projectUpdate, name: e.target.value })
            }
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />

          <br />
          <TextField
            margin="dense"
            id="project_type"
            label={
              <span style={{ fontSize: "13px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>
                Project Type <span style={{ color : "#ff4d4d" }}>*</span>
              </span>
            }
            type="text"
            variant="standard"
            fullWidth
            value={projectUpdate && projectUpdate.type}
            onChange={(e) =>
              setProjectUpdate({ ...projectUpdate, type: e.target.value })
            }
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />
          <br />
          <TextField
            margin="dense"
            id="project_genre"
            label={
              <span style={{ fontSize: "13px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>
                Project Genre <span style={{ color : "#ff4d4d" }}>*</span>
              </span>
            }
            type="text"
            variant="standard"
            fullWidth
            value={projectUpdate && projectUpdate.genre}
            onChange={(e) =>
              setProjectUpdate({ ...projectUpdate, genre: e.target.value })
            }
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />
          <br />
          <TextField
            margin="dense"
            id="project_by"
            label={
              <span style={{ fontSize: "13px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>
                Project By <span style={{ color : "#ff4d4d" }}>*</span>
              </span>
            }
            type="text"
            variant="standard"
            fullWidth
            value={projectUpdate && projectUpdate.project_by}
            onChange={(e) =>
              setProjectUpdate({ ...projectUpdate, project_by: e.target.value })
            }
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />
          <br />
          <TextField
            margin="dense"
            id="script_writer_name"
            label={
              <span style={{ fontSize: "13px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>
                Script Wrtter Name <span style={{ color : "#ff4d4d" }}>*</span>
              </span>
            }
            type="text"
            variant="standard"
            fullWidth
            value={projectUpdate && projectUpdate.script_writer_name}
            onChange={(e) =>
              setProjectUpdate({
                ...projectUpdate,
                script_writer_name: e.target.value,
              })
            }
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />
          <br />
          <label htmlFor="banner_file" style={{ fontSize: "10px", color: theme.palette.themeMode == "dark" ? "#fff" : "#000" }}>Banner File</label>          
          <TextField
            margin="dense"
            id="banner_file"
            type="file"
            variant="standard"
            fullWidth
            inputProps={{ accept: "image/*" }}
            sx={{
              input: { color: theme.palette.themeMode == "dark" ? "#fff" : "#000" },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#314BCA",
              },
            }}
          />
          <br />
        </DialogContent>
        <DialogActions>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <div className="error" style={{ width: "100%" }}>
                {dialogError}
              </div>
            </Grid>
            <Grid
              item
              container
              spacing={2}
              sx={{ display: "flex", justifyContent: "right" }}
            >
              <Grid item>
                <Button style={ButtonStyles(theme)} size="small" onClick={handleDialogClose}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                {submitted ? (
                  redirect ? null : (
                    <>
                      <Button style={ButtonStyles(theme)} size="small" disabled>
                        Submit
                      </Button>
                      <Backdrop open={true} sx={BackdropStyles()}>
                        <CircularProgress sx={{ ...CircularProgressStyles(), color: "#314BCA" }}/>
                      </Backdrop>
                    </>
                  )
                ) : (
                  <Button style={ButtonStyles(theme)} size="small" onClick={handleProjectSubmit}>
                    Submit
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={filterErrorDialog}
        // onClose={handleDialogClose}
        onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              handleDialogClose();
            }
          }}
        sx={DialogStyles(theme)}
      >
        <DialogContent>
          <Typography style={{ fontWeight: "bold", color: "red" }}>
            Failed to Change Filter, Try Again
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button style={ButtonStyles(theme)} size="small" onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FixedMenuLayout;
